import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/assets/styles/main.scss'
import ElementPlus from 'element-plus'
import {RouterView} from 'vue-router'
import i18n from '@/lib/i18n'
import {createApp} from 'vue'
import {createPinia} from 'pinia'
import router from './router'
import init from '@/lib/init'
import {initSentry} from '@/lib/sentry'
import {filters} from '@/utils/filters'

const app = createApp(RouterView)

initSentry(app)

app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.use(i18n)

app.config.globalProperties.$filters = filters

init(() => app.mount('#app'))
